import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { DollarSign, Calendar, Video, Users } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ForCoaches = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      {/* Hero Section */}
      <section className="py-20 px-4">
        <div className="container mx-auto text-center">
          <h1 className="text-5xl font-bold mb-6">Become a Vocal Coach</h1>
          <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
            Share your passion for singing and help aspiring vocalists reach their goals. 
            Set your own schedule, work from anywhere, and build your teaching business.
          </p>
          <Button size="lg" onClick={() => navigate("/apply-coach")}>
            Apply Now
          </Button>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 px-4 bg-muted/50">
        <div className="container mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12">Why Teach With Us?</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <Card>
              <CardHeader>
                <DollarSign className="w-12 h-12 mb-4 text-primary" />
                <CardTitle>Competitive Earnings</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription>
                  Earn $1.99 per minute of lessons. You keep the majority of your earnings with transparent pricing.
                </CardDescription>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <Calendar className="w-12 h-12 mb-4 text-primary" />
                <CardTitle>Flexible Schedule</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription>
                  Set your own availability and manage your calendar. Block off time when you need it.
                </CardDescription>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <Video className="w-12 h-12 mb-4 text-primary" />
                <CardTitle>Online Platform</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription>
                  Teach from anywhere with our integrated video conferencing. No commute necessary.
                </CardDescription>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <Users className="w-12 h-12 mb-4 text-primary" />
                <CardTitle>Growing Student Base</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription>
                  Get matched with motivated students who are eager to learn and improve their vocal skills.
                </CardDescription>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Requirements Section */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-3xl">
          <h2 className="text-3xl font-bold text-center mb-12">Coach Requirements</h2>
          <Card>
            <CardContent className="pt-6">
              <ul className="space-y-4">
                <li className="flex items-start">
                  <span className="mr-2">✓</span>
                  <span>Professional vocal training or equivalent experience</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">✓</span>
                  <span>Ability to teach various skill levels (beginner to advanced)</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">✓</span>
                  <span>Reliable internet connection and professional setup</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">✓</span>
                  <span>Excellent communication and teaching skills</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">✓</span>
                  <span>Commitment to student success and professional conduct</span>
                </li>
              </ul>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-primary/5">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl font-bold mb-6">Ready to Start Teaching?</h2>
          <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
            Join our community of passionate vocal coaches and help students discover their voice.
          </p>
          <Button size="lg" onClick={() => navigate("/apply-coach")}>
            Apply to Become a Coach
          </Button>
        </div>
      </section>
    </div>
  );
};

export default ForCoaches;
